import { PlusSquareIcon, QuestionIcon } from '@chakra-ui/icons'
import {
  ChakraProvider,
  HStack,
  Stack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  useDisclosure,
  Input,
  Textarea,
  Image,
  Checkbox,
  CheckboxGroup,
  Select as ChakraSelect,
  keyframes,
} from '@chakra-ui/react'
import { SingleDatepicker } from 'chakra-dayzed-datepicker'

import { MultiSelect, Option } from 'chakra-multiselect'
import { getHours, isWeekend, parse, addMinutes, isBefore, format, addDays } from 'date-fns'
import { useEffect, useState } from 'react'
import Api from '../api/api'
const CallWaiterButton = () => {
  const [waiterCalled, setWaiterCalled] = useState(null);

  const glow = keyframes`
  0% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.4),
     0 0 10px rgba(255, 0, 0, 0.4),
     0 0 20px rgba(255, 0, 0, 0.4),
     0 0 40px rgba(255, 0, 0, 0.4);
  }
  50% {
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.8),
     0 0 20px rgba(255, 0, 0, 0.8),
     0 0 30px rgba(255, 0, 0, 0.8),
     0 0 50px rgba(255, 0, 0, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.4),
     0 0 10px rgba(255, 0, 0, 0.4),
     0 0 20px rgba(255, 0, 0, 0.4),
     0 0 40px rgba(255, 0, 0, 0.4);
  }
`

 useEffect(() => {
   const fetchWaiterStatus = async () => {
     Api.getCallWaiter().then((data) => {
      setWaiterCalled(data.waiterCalled)
     });
   }
   fetchWaiterStatus()
   const intervalId = setInterval(fetchWaiterStatus, 5000)

   return () => clearInterval(intervalId)
 }, [])

  const onClick = () => {
    setWaiterCalled(null)
    Api.dismissWaiterCalled()
  };


  return (
    <>
      {waiterCalled && (
        <Button
          onClick={onClick}
          position='fixed'
          bottom={4}
          left='50%'
          transform='translateX(-50%)'
          variant='solid'
          colorScheme='orange'
          sx={{
            animation: `${glow} 1s infinite alternate`,
          }}
          height={12}
        >
          <VStack spacing={0} height="full" paddingTop={2}>
            <Text>Terace called for waiter</Text>
            <Text>{waiterCalled}</Text>
          </VStack>
        </Button>
      )}
    </>
  )
}

export default CallWaiterButton
